/**
 * MarketplaceStrip - widget for client dashboard showing approved B2B ads.
 */
import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ExternalLink, Megaphone } from "lucide-react";
import { api } from "@/lib/api";

export default function MarketplaceStrip() {
    const [ads, setAds] = useState([]);

    useEffect(() => {
        api.get("/ads/marketplace?limit=6").then((r) => setAds(r.data)).catch(() => {});
    }, []);

    const handleClick = (ad) => {
        api.post(`/ads/${ad.id}/click`).catch(() => {});
        window.open(ad.target_url, "_blank", "noopener,noreferrer");
    };

    if (!ads || ads.length === 0) return null;

    return (
        <Card className="glass-card p-5 rounded-2xl" data-testid="dashboard-marketplace">
            <div className="flex items-center justify-between mb-4 gap-2">
                <div className="flex items-center gap-2">
                    <Megaphone className="h-4 w-4 text-[#A78BFA]" />
                    <h3 className="font-display text-lg font-semibold">Marketplace MeSafa</h3>
                </div>
                <Badge variant="outline" className="text-xs border-[#6B21D9]/30 bg-[#6B21D9]/10 text-[#A78BFA]">
                    Serviços B2B em Angola
                </Badge>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {ads.slice(0, 6).map((a) => (
                    <button
                        key={a.id}
                        onClick={() => handleClick(a)}
                        className="text-left rounded-xl bg-card border border-white/8 hover:border-[#6B21D9]/40 hover:scale-[1.01] transition-all overflow-hidden"
                        data-testid={`marketplace-ad-${a.id}`}
                    >
                        {a.image_url && (
                            <div className="aspect-video bg-black/30 overflow-hidden">
                                <img src={a.image_url} alt="" className="w-full h-full object-cover" />
                            </div>
                        )}
                        <div className="p-3">
                            <Badge variant="outline" className="text-[10px] mb-1">{a.industry || "Serviço"}</Badge>
                            <h4 className="font-semibold text-sm leading-tight line-clamp-1">{a.title}</h4>
                            <p className="mt-1 text-xs text-muted-foreground line-clamp-2">{a.headline}</p>
                            <div className="mt-2 flex items-center justify-between">
                                <span className="text-[11px] text-muted-foreground line-clamp-1">{a.advertiser_company || a.advertiser_name}</span>
                                <span className="text-[11px] text-[#A78BFA] flex items-center gap-1">
                                    {a.cta_label} <ExternalLink className="h-3 w-3" />
                                </span>
                            </div>
                        </div>
                    </button>
                ))}
            </div>
            <p className="mt-3 text-[11px] text-muted-foreground text-center">
                Conteúdo patrocinado por subscritores MeSafa. Os anúncios passam por revisão pela equipa.
            </p>
        </Card>
    );
}
